import { BrandMark } from '../lib/brand';
import { AuthenticateWithRedirectCallback, SignIn, SignUp } from '@clerk/react';
import { authReturnPath } from '@/lib/auth-routing';
import './auth.css';

export function AuthScreen({ configured }: { configured: boolean }) {
  const returnPath = authReturnPath(
    location.search,
    location.hash,
    location.origin,
  );
  const signInUrl = `/sign-in?return_to=${encodeURIComponent(returnPath)}`;
  const signUpUrl = `/sign-up?return_to=${encodeURIComponent(returnPath)}`;
  const redirect = `${location.origin}${returnPath}`;
  return (
    <main className="auth-screen">
      <a className="auth-brand" href="/">
        <BrandMark size={52} />streamit<span>.</span>
      </a>
      <p className="auth-intro">Your library. Your screens.</p>
      {!configured ? (
        <p>
          Sign-in is being configured. <a href="/">Back to Streamit</a>
        </p>
      ) : location.hash.startsWith('#/sso-callback') ? (
        <>
          <p role="status">Finishing your sign-in…</p>
          <AuthenticateWithRedirectCallback
            signInUrl={signInUrl}
            signUpUrl={signUpUrl}
            signInForceRedirectUrl={redirect}
            signUpForceRedirectUrl={redirect}
          />
        </>
      ) : location.pathname.startsWith('/sign-up') ? (
        <SignUp
          routing="path"
          path="/sign-up"
          oauthFlow="redirect"
          signInUrl={signInUrl}
          forceRedirectUrl={redirect}
        />
      ) : (
        <SignIn
          routing="path"
          path="/sign-in"
          oauthFlow="redirect"
          signUpUrl={signUpUrl}
          forceRedirectUrl={redirect}
          signUpForceRedirectUrl={redirect}
        />
      )}
      <nav aria-label="Account information">
        <a href="/privacy.html">Privacy</a>
        <a href="/terms.html">Terms</a>
        <a href="/about.html">About Streamit</a>
        <a href="/setup">Set up a TV</a>
      </nav>
    </main>
  );
}
